import { defineCharacter } from 'fumika'

export default defineCharacter({})({
  name: '채팅창',
  bases: {},
  emotions: {}
})
